import formComponent from '@/util/proto/formComponent'
import { phoneValidator , bankCardValidator } from '@/util/validator'

export default {
  extends: formComponent ,
  components:{ },
  data() {
    return {
      formData: {
        name: {
          rules:[
            { required: true, message: '请输入姓名', trigger: 'blur,change' },
          ]
        },
        phone: {
          rules:[
            { required: true, trigger: 'blur,change' ,validator: phoneValidator('请输入手机号', '请输入正确格式的手机号')},
          ]
        },
        account:{
          rules:[
            { required: true, message: '请输入用户账号', trigger: 'blur,change' },
            { type: 'string', min: 1, max: 20, message: '用户账号最多20个字符', trigger: 'blur,change' }
          ]
        },
        password:{
          rules:[
            { required: true, message: '请输入密码', trigger: 'blur' },
            { type: 'string', min: 1, max: 30, message: '最多30字符', trigger: 'change' }
          ]
        },
        bankCard:{
          rules:[
            { required: false, message: '请输入银行卡号', trigger: 'blur' },
            { validator: bankCardValidator(), trigger: 'blur,change' },
          ]
        },
        repairSiteId:{
          rules:[
            { required: true, type:'number',message: '请选择所属站点', trigger: 'blur,change' },
          ]
        },
        roleIds: {
          initialValue:[],
          rules:[
            { type: 'array', required: true, message: '请选择角色', trigger: 'blur,change' },
          ]
        },
        // appSystem:null,
      },
      id:null,
      loading:false,
      roles:[],
      visible:false,
      api:['assUserCreate','assUserUpdate']
    }
  },

  computed:{
    title(){
      return this.id ? '修改用户' : '新增用户'
    },
    passwordDecorator(){
      return [
        'password',
        {
          rules:[{ required: !this.id , message: '请输入密码名称', trigger: 'blur,change' }]
        }
      ]
    },
    branchs(){
      return new Promise((resolve , reject) => {
        return this.$request.assBranchsAll().then( resp => {
          resolve( resp.data.map(i => ({value:i.id , label:i.repairSiteName})))
        })
      })
    }
  },

  methods: {
    init(id) {
      this.id = id
      this.visible = true
      this.$resetFormData()
      if(this.id){
        this.query()
      }
    },

    query(){
      this.loading = true
      this.$request.assUser(this.id).then(resp => {
        resp.data.roleIds = resp.data.roles.map(i => i.id)
        this.$setFormData(resp.data)
        this.loading = false
      })
    },
    beforeSave(d){
      let params = { ...d }
      if(this.id){
        params.id = this.id
      }
      if(!params.password){
        delete params.password
      }
      return params
    }
  },

  render(){
    return (
      <sl-side-panel v-model={this.visible} loading={this.loading} title={this.title}>
        <sl-form label-width={100}>
          {/*<sl-form-item label="所属系统">
            <sl-select disabled={!!this.id} v-decorator={this.formData.appSystem} dict="$appSystem" clearable={true}></sl-select>
          </sl-form-item>*/}
          <sl-form-item label="用户名">
            <Input v-decorator={this.formData.name}></Input>
          </sl-form-item>
          <sl-form-item label="手机号">
            <Input v-decorator={this.formData.phone}></Input>
          </sl-form-item>
          <sl-form-item label="登录名">
            <Input disabled={!!this.id} v-decorator={this.formData.account}></Input>
          </sl-form-item>
          <sl-form-item label="密码">
            <Input v-decorator={this.passwordDecorator}></Input>
          </sl-form-item>
          <sl-form-item label="所属站点">
            <sl-select dict={this.branchs} v-decorator={this.formData.repairSiteId} />
          </sl-form-item>
          <sl-form-item label="角色">
            <sl-select multiple={true} dict="$$role_repair" v-decorator={this.formData.roleIds} />
          </sl-form-item>
        </sl-form>
        <template slot="footer">
          <Button loading={this.loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </template>
      </sl-side-panel>
    )
  }
}